import { PointAlert } from '@/components/PointAlert';
import { KnotAlert } from '@/features/knots/KnotAlert';
import { PendingKnotAlert } from '@/features/knots/PendingKnotAlert';
import { PriceAlertWatcher } from '@/features/alerts/PriceAlertWatcher';

/**
 * The alerts, as bars stacked under the top bar.
 *
 * Rendered inside the sticky header, so they stay in view while the page
 * scrolls, and in priority order: a price line you set yourself first, then
 * the module alerts, then the time-point countdown. Each alert only describes
 * its own bar (see AlertBar); this owns where they go.
 *
 * `empty:hidden` drops the padding when nothing is showing — every child
 * renders nothing at all then, so the wrapper is truly empty.
 */
export function AlertStack() {
  return (
    <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-1.5 px-4 py-2 empty:hidden sm:px-6">
      <PriceAlertWatcher />
      <KnotAlert />
      <PendingKnotAlert />
      <PointAlert />
    </div>
  );
}
